<div id="sidebar-wrapper">
  <div class="sidebar-heading">
    <a [routerLink]="['/user/dashboard']">
      <img src="../../../../assets/images/logos/takeabreath_logo_new_font.svg">
    </a>
  </div>
  <div class="list-group list-group-flush">
    <a
      [routerLink]="['/admin/dashboard']"
      class="list-group-item list-group-item-action"
      [ngClass]="{'active': routeActive == 'Dashboard'}"
    >
      Dashboard
    </a>
    <a
      [routerLink]="['/admin/series']"
      class="list-group-item list-group-item-action"
      [ngClass]="{'active': routeActive == 'Series & Modules'}"
    >
      Series & Modules
    </a>
    <a
      [routerLink]="['/admin/organisations']"
      class="list-group-item list-group-item-action"
      [ngClass]="{'active': routeActive == 'Enterprises' || routeActive == 'Enterprise Edit'}"
    >
      Enterprises
    </a>
    <a
      [routerLink]="['/admin/users']"
      class="list-group-item list-group-item-action"
      [ngClass]="{'active': routeActive == 'Users'}"
    >
      Users
    </a>
    <a
      *ngIf="showDeviceDelivery"
      [routerLink]="['/admin/device-orders']"
      class="list-group-item list-group-item-action"
      [ngClass]="{'active': routeActive == 'Device Orders'}"
    >
      Device Orders
    </a>
    <a
      [routerLink]="['/admin/billing-history']"
      class="list-group-item list-group-item-action"
      [ngClass]="{'active': routeActive == 'Billing History'}"
    >
      Billing History
    </a>
    <a
      class="list-group-item list-group-item-action"
      (click)="showResourcesSubMenu = !showResourcesSubMenu"
    >
      <div class="d-flex align-items-center submenu-link" [ngClass]="{'active': showResourcesSubMenu}">
        <p class="mr-auto mb-0 noselect">Resources</p>
        <i class="fa fa-angle-{{ (showResourcesSubMenu) ? 'up' : 'down' }}"></i>
      </div>
    </a>
    <ul *ngIf="showResourcesSubMenu" class="list-group list-unstyled pl-4 submenus-container">
      <a [routerLink]="['/admin/resources/audio-pods']">
        <li class="noselect submenus-item p-2" [ngClass]="{'active': routeActive === 'Audio Pods'}">Audio Pods</li>
      </a>
      <a [routerLink]="['/admin/resources/science']">
        <li class="noselect submenus-item p-2" [ngClass]="{'active': routeActive === 'Science'}">Science</li>
      </a>
      <a [routerLink]="['/admin/resources/community']">
        <li class="noselect submenus-item p-2" [ngClass]="{'active': routeActive === 'Community'}">Community</li>
      </a>
    </ul>
    <a
      [routerLink]="['/admin/push-notifications']"
      class="list-group-item list-group-item-action"
      [ngClass]="{'active': routeActive == 'Push Notifications'}"
    >
      Push Notifications
    </a>
    <a
      [routerLink]="['/admin/challenge-report']"
      class="list-group-item list-group-item-action"
      [ngClass]="{'active': routeActive == '7-Day Challenge Results'}"
    >
      7-Day Challenge Results
    </a>
    <a
      (click)="authService.logout()"
      class="list-group-item list-group-item-action"
    >
      Log Out
    </a>
  </div>
</div>
